import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[ellFileDrop]',
    standalone: true
})
export class FileDropDirective {
    /**
     * Marks that the object is being hovered over with something
     */
    @HostBinding('class.text-bg-info')
    hovered = false;

    @Output()
    filesDropped = new EventEmitter<FileList>();

    constructor() { }

    @HostListener('dragover', ['$event'])
    public onDragOver($event: DragEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.hovered = true;
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave($event: DragEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.hovered = false;

    }

    @HostListener('drop', ['$event'])
    public onDrop($event: DragEvent) {
        $event.preventDefault();
        $event.stopPropagation();
        this.hovered = false;

        const files = $event.dataTransfer?.files;
        if (files?.length) {
            this.filesDropped.emit(files);
        }
    }
}
